module.exports = __webpack_public_path__ + "06bb99ba104c6d59113cde446d6a8732.svg";